module.exports = __webpack_public_path__ + "img/ok.f2e00b72.png";